import { render, staticRenderFns } from "./InvoiceLoader.vue?vue&type=template&id=10061890&scoped=true"
import script from "./InvoiceLoader.vue?vue&type=script&lang=js"
export * from "./InvoiceLoader.vue?vue&type=script&lang=js"
import style0 from "./InvoiceLoader.vue?vue&type=style&index=0&id=10061890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10061890",
  null
  
)

export default component.exports